// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SpeakerVideo__container-e3d445 {
  position: relative;
  overflow: hidden;
  max-width: 100%;
}

.SpeakerVideo__speaker-container-abb8ef {
  position: relative;
  width: 100%;
  height: 100%;
  max-height: 100%;
  transition: max-height 200ms ease-in-out;
}

.SpeakerVideo__speaker-container-with-opponents-b50029 {
  max-height: calc(100% - 92px);
}

.SpeakerVideo__speaker-c40a89 {
  height: 100%;
  margin: 0 var(--indent-8px);
  border-radius: 8px;
}

.SpeakerVideo__toggle-opponents-ba104a {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 56px;
  z-index: 1;
  cursor: pointer;
}

.SpeakerVideo__toggle-opponents-ba104a:hover .SpeakerVideo__icon-bba8f9 {
  background-color: var(--addition-110_50);
}

.SpeakerVideo__toggle-opponents-ba104a:active .SpeakerVideo__icon-bba8f9 {
  background-color: var(--addition-110_60);
}

.SpeakerVideo__icon-bba8f9 {
  border-radius: 50%;
  fill: var(--addition-50);
  padding: 8px;
  transform: rotate(-90deg);
  background-color: var(--addition-110_40);
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/CallView/CompactCallView/Shared/SpeakerVideo/SpeakerVideo.styles.m.css"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;AACF;;AAEA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,wCAAA;AACF;;AAEA;EACE,6BAAA;AACF;;AAEA;EACE,YAAA;EACA,2BAAA;EACA,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;AACF;;AAEA;EACE,wCAAA;AACF;;AAEA;EACE,wCAAA;AACF;;AAEA;EACE,kBAAA;EACA,wBAAA;EACA,YAAA;EACA,yBAAA;EACA,wCAAA;AACF","sourcesContent":[".container {\n  position: relative;\n  overflow: hidden;\n  max-width: 100%;\n}\n\n.speaker-container {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  max-height: 100%;\n  transition: max-height 200ms ease-in-out;\n}\n\n.speaker-container-with-opponents {\n  max-height: calc(100% - 92px);\n}\n\n.speaker {\n  height: 100%;\n  margin: 0 var(--indent-8px);\n  border-radius: 8px;\n}\n\n.toggle-opponents {\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  height: 56px;\n  z-index: 1;\n  cursor: pointer;\n}\n\n.toggle-opponents:hover .icon {\n  background-color: var(--addition-110_50);\n}\n\n.toggle-opponents:active .icon {\n  background-color: var(--addition-110_60);\n}\n\n.icon {\n  border-radius: 50%;\n  fill: var(--addition-50);\n  padding: 8px;\n  transform: rotate(-90deg);\n  background-color: var(--addition-110_40);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SpeakerVideo__container-e3d445`,
	"speaker-container": `SpeakerVideo__speaker-container-abb8ef`,
	"speakerContainer": `SpeakerVideo__speaker-container-abb8ef`,
	"speaker-container-with-opponents": `SpeakerVideo__speaker-container-with-opponents-b50029`,
	"speakerContainerWithOpponents": `SpeakerVideo__speaker-container-with-opponents-b50029`,
	"speaker": `SpeakerVideo__speaker-c40a89`,
	"toggle-opponents": `SpeakerVideo__toggle-opponents-ba104a`,
	"toggleOpponents": `SpeakerVideo__toggle-opponents-ba104a`,
	"icon": `SpeakerVideo__icon-bba8f9`
};
module.exports = ___CSS_LOADER_EXPORT___;
